import { render, staticRenderFns } from "./PageDialog.vue?vue&type=template&id=d0e34ace&"
import script from "./PageDialog.vue?vue&type=script&lang=js&"
export * from "./PageDialog.vue?vue&type=script&lang=js&"
import style0 from "./PageDialog.vue?vue&type=style&index=0&id=d0e34ace&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VCol,VContainer,VRow})
